// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1XmBF","list":"BalanceDue_list__1p139","listRow":"BalanceDue_listRow__3rGp8","total":"BalanceDue_total__1OtuX"};